<template>
  <v-data-table
    dense
    class="benefits-table"
    :options.sync="options"
    :loading="loading"
    :headers="headers"
    :search="search"
    :items="balances"
    :items-per-page="20"
    :footer-props="{ 'items-per-page-options': [10, 20, 50, 100, 500] }"
    :expanded.sync="expanded"
    show-expand
    :no-data-text="
      planIdentity.HasDrupalPortal
        ? $t('components.benefits_balances.no_data_available')
        : $t('components.benefits_balances.coming_soon')
    "
    item-key="LabelEn"
    @click:row="setExpanded"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td
          class="text-start expand-icon-detail"
        >
          <v-icon
          v-if="item.SubBenefits && item.SubBenefits.length"
            @click="setExpanded(item)"
            class="v-data-table__expand-icon"
            :class="{ 'v-data-table__expand-icon--active': item.isExpanded }"
          >
            mdi-chevron-down
          </v-icon>
        </td>
        <td
          v-if="$vuetify.lang.current === 'fr'"
          class="text-subtitle-2 text-left w320"
          :class="item.IsGroupHeader ? 'font-weight-bold' : ''"
        >
          {{ item.LabelFr }}
        </td>
        <td
          v-else
          class="text-subtitle-2 text-left w320"
          :class="item.IsGroupHeader ? 'font-weight-bold header-cell' : ''"
        >
          {{ item.LabelEn }}
        </td>
        <td class="text-subtitle-2 text-left" style="min-width: 160px">
          <template v-if="item.AllowedMessage">
            {{
              $helpers.fillFormattedParams(
                item.AllowedMessage.message
                  ? $t(
                      "components.benefits_balances_table.message." +
                        item.AllowedMessage.message
                    )
                  : "",
                item.AllowedMessage.formattedParams
              )
            }}
          </template>
        </td>
        <td class="text-subtitle-2 text-left w120">
          {{
            item.UsedMessage
              ? $helpers.fillFormattedParams(
                  item.UsedMessage.message,
                  item.UsedMessage.formattedParams
                )
              : item.Used
          }}
        </td>
        <td class="text-subtitle-2 text-left w120">
          {{
            item.RemainingMessage
              ? $helpers.fillFormattedParams(
                  item.RemainingMessage.message,
                  item.RemainingMessage.formattedParams
                )
              : item.Remaining
          }}
        </td>
        <td class="text-subtitle-2 text-left w250">
          {{ $helpers.formatDate(item.RenewalDate) }}
        </td>
      </tr>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:expanded-item="{ headers, item }">
      <td class="expanded-detail" :colspan="headers.length">
        <benefit-detail :subBenefits="item.SubBenefits" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import BenefitDetail from "@/components/MemberView/BenefitBalance/BenefitDetail.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BenefitDetail,
  },
  props: {
    loading: Boolean,
    reset: Boolean,
    tableOptions: {
      type: Object,
      default: () => {},
    },
    searchString: String,
    balances: Array,
    planBenefits: Array,
  },
  data() {
    return {
      options: { sortDesc: [true] },
      page: 1,
      search: "",
      expanded: [],
      selected: [],
    };
  },
  watch: {
    options: {
      handler(v) {
        this.$emit("pagination", v);
      },
      deep: true,
    },
    searchString: {
      handler(v) {
        this.search = v;
        this.selected = [];
      },
      immediate: true,
    },
    selected: {
      handler(v) {
        if (v.length) this.$emit("row-selected", v[0]);
      },
      deep: true,
      immediate: true,
    },
    reset: {
      handler() {
        this.search = "";
      },
      immediate: true,
    },
    // balances: {
    //   handler(v) {
    //     if (v?.length) {
    //       v.forEach((item) => {
    //         if (item.IsGroupHeader) this.expanded.push(item);
    //       });
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  computed: {
    ...mapGetters("plansMembers", ["planIdentity"]),
    headers() {
      return [
        // {
        //   text: "",
        //   value: "data-table-select",
        //   class: `text-subtitle-2 ${
        //     this.$vuetify.breakpoint.smAndUp ? "primary" : ""
        //   } white--text select-all-checkbox`,
        //   cellClass: "single-select",
        // },
        {
          text: "",
          value: "data-table-expand",
          cellClass: "expand",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t("components.claims_history.coverage_benefit"),
          align: "left",
          sortable: true,
          value: this.$vuetify.lang.current === "fr" ? "LabelFr" : "LabelEn",
          cellClass: "text-subtitle-2 pl-4",
          class: "text-subtitle-2 primary white--text pl-4",
        },
        {
          text: this.$t("components.benefits_balances_table.header.allowed"),
          align: "left",
          sortable: true,
          value: "Allowed",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t("components.benefits_balances_table.header.used"),
          align: "left",
          sortable: true,
          value: "Used",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t("components.benefits_balances_table.header.remaining"),
          align: "left",
          sortable: true,
          value: "Remaining",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t(
            "components.benefits_balances_table.header.rewnewal_date"
          ),
          align: "left",
          sortable: true,
          value: "RenewalDate",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
      ];
    },
  },
  methods: {
    setExpanded(item) {
      console.log(item.isExpanded, this.expanded)
      if (item.SubBenefits?.length) {
        if (item.isExpanded) {
          this.expanded = this.expanded.filter((o)=>o.LabelEn !== item.LabelEn);
        } else {
          this.expanded.push(item);
        }
        item.isExpanded = !item.isExpanded;
      }
    },
    setSelected(item) {
      this.selected = [item];
      this.$emit("row-selected", item);
    },
    calculateUsedPerGroup(items) {
      return items.reduce((accumulator, item) => {
        return accumulator + item.Used;
      }, 0);
    },
    calculateRemainingPerGroup(items) {
      let sum = items.reduce((accumulator, item) => {
        return accumulator + item.Used;
      }, 0);
      return items[0].Allowed - sum;
    },
    getItemClass(item) {
      if (item.GroupEN) {
        return "grey lighten-3";
      }
      return "";
    },
    // getPatientNames(claim) {
    //   let patients = {};
    //   console.log(claim);
    //   // claim.ClaimHistoryDetails.forEach((c) => {
    //   //   patients[this.$helpers.capitalize(c.PatientName).trim()] = true;
    //   // });
    //   return Object.keys(patients).join(", ");
    // },
    formatPaidTo(paidTo) {
      if (!paidTo) return;
      let paidToTrimmed = paidTo.trim();
      if (paidToTrimmed !== "M" && paidToTrimmed !== "P") paidToTrimmed = "P";
      return this.$helpers.formatEnumModel(
        paidToTrimmed,
        "PaidTo",
        this.$vuetify.lang.current
      );
    },
    // formatAllowedMessage(item) {
    //   if (!item.AllowedMessage) return "";
    //   let allowedMessage = item.AllowedMessage;
    //   let message = allowedMessage?.message ?? "";
    //   if (allowedMessage.formattedParams?.length) {
    //     allowedMessage.formattedParams.forEach((param) => {
    //       message = message.replace("{}", param);
    //     });
    //   }
    //   return message;
    // },
    formatChequeStatus(chequeStatus) {
      if (!chequeStatus) return;
      let chequeStatusTrimmed = chequeStatus.trim();
      const value = this.$t(
        `components.claims_history.cheque_status.${chequeStatusTrimmed}`
      );
      return value || "";
    },
    // filterByDateRange(value) {
    //   if (this.dateRange.length === 1 && value === this.dateRange[0])
    //     return true;
    //   if (this.dateRange.length === 1 && value !== this.dateRange[0])
    //     return false;
    //   if (this.dateRange.length === 2) {
    //     const date = new Date(value);
    //     const start = new Date(this.dateRange[0]);
    //     const end = new Date(this.dateRange[1]);
    //     if (date >= start && date <= end) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   }

    //   return true;
    // },
    printSelected() {
      this.$emit("print-selected", {
        headers: this.headers,
        items: this.selected,
        title: this.$t(
          "components.claims_history.printout.paid_claims_history"
        ),
      });
    },
  },
};
</script>
<style scoped>
.benefits-table >>> tbody tr:hover {
  cursor: pointer;
}
.benefits-table >>> .v-data-table-header__icon {
  color: white !important;
}
.benefits-table >>> th {
  padding: 0 8px !important;
  background-color: var(--primary);
}
.benefits-table >>> td {
  padding: 0 !important;
}
.benefits-table >>> td.expand-icon {
  padding: 0 0 0 4px !important;
}
.benefits-table >>> td.expanded-detail {
  padding: 0 0 0 0px !important;
}
.benefits-table >>> th.select-all-checkbox {
  padding-left: 8px !important;
}
.benefits-table >>> td.single-select {
  padding-right: 4px !important;
}
.benefits-table >>> .v-data-table__expanded__row {
  background-color: #cbcbcb !important;
}
.select-all-checkbox >>> .theme--light.v-icon {
  color: white !important;
}
.benefits-table >>> .expand {
  padding: 0;
  width: 28px !important;
}
.benefits-table >>> tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.06);
}
.benefits-table >>> tr:has(.expand-icon) {
  background-color: #008080 !important;
}
.v-tooltip__content {
  max-width: 100px !important;
}
.w250 {
  width: 250px
}
.w120 {
  width: 120px
}
.w320 {
  width: 320px
}
.mw160 {
  min-width: 160px
}
.expand-icon-detail {
  padding: 0 0 0 8px !important;
  width: 28px !important;
}
</style>
